// extracted by mini-css-extract-plugin
export default {"content":"index_content_Li1IY","blank":"index_blank_Byxy4","callClientLiveBox":"index_callClientLiveBox_AVPAg","callClientLive":"index_callClientLive_f5wQq"};